import {Component, OnInit} from '@angular/core';
import {TreeNode, SelectItem, Message} from 'primeng/primeng';
import {UserService} from '../services/user.service';

@Component({
    selector: 'app-hierarchy',
    templateUrl: './hierarchy.component.html',
    styleUrls: ['./hierarchy.component.css']
})
export class HierarchyComponent implements OnInit {

    msgs: Message[] = [];
    users: any[];
    usersRoot: any[];
    userSelected: any;
    blockedDocument: boolean = false;
    displayEdit: boolean = false;
    usersParents: SelectItem[];

    constructor(private userService: UserService) {
    }

    ngOnInit() {
        this.init();
    }

    init() {
        this.blockedDocument = true;

        this.users = [];
        this.userService.findAll().then(data => {
            let response: any = data;
            response.users.forEach(item => {
                this.users.push(item);
            });
        }).catch(err => {
            console.log(err);
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: err}];
        });

        this.usersRoot = [];
        this.userService.findUsersRoot().then(data => {
            let response: any = data;
            response.users.forEach(item => {
                item.children = [];

                this.userService.getUserTree(item.idUser).then(dataChildren => {
                    let responseChildren: any = dataChildren;
                    item.children.push({
                        label: item.nickName + '-' + item.profile,
                        idUser: item.idUser,
                        children: responseChildren.nodes
                    });
                    this.usersRoot.push(item);
                }).catch(err => {
                    console.log(err);
                    this.msgs = [{severity: 'error', summary: 'ERROR', detail: err}];
                    this.blockedDocument = false;
                });
            });
            this.blockedDocument = false;
        }).catch(err => {
            console.log(err);
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: err}];
            this.blockedDocument = false;
        });
        this.hide();
    }

    hide() {
        this.displayEdit = false;
    }

    configUser(event) {
        this.usersParents = [];
        this.usersParents.push({label: 'Ninguno', value: ''});
        this.users.forEach(item => {
            if (item.idUser == event.node.idUser) {
                this.userSelected = item;
                this.displayEdit = true
            } else {
                this.usersParents.push({label: item.nickName, value: item.idUser});
            }
        });
    }

    edit() {
        this.userService.edit(this.userSelected).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                this.init();
                this.msgs = [{severity: 'info', summary: 'INFO', detail: 'Registro modificado exitosamente'}];
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
            this.blockedDocument = false;
        }).catch(err => {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: err}];
            this.blockedDocument = false;
        });
    }

    expandAll() {
        this.usersRoot.forEach(user => {
            user.children.forEach(node => {
                this.expandRecursive(node, true);
            });
        });
    }

    collapseAll() {
        this.usersRoot.forEach(user => {
            user.children.forEach(node => {
                this.expandRecursive(node, false);
            });
        });
    }

    private expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (node.children) {
            node.children.forEach(childNode => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/hierarchy/hierarchy.component.ts